import * as stateMachine from 'rwwa-rx-state-machine'

export const GiddyUpTabChanged = stateMachine.createSignal('GiddyUpTabChanged')
export const QuaddieValueChanged = stateMachine.createSignal('QuaddieValueChanged')
